import type { ProductOption } from "@kanpla/api-contract";
import { cva } from "class-variance-authority";

import { T } from "@repo/transifex";

const variantHintStyles = cva("text-xl", {
  variants: {
    error: {
      false: "text-kiosk-text-secondary",
      true: "text-kiosk-text-error"
    }
  }
});

type VariantHintProps = {
  minimum: ProductOption["minimum"];
  maximum: ProductOption["maximum"];
  error: boolean;
};

export const VariantHint = ({ minimum, maximum, error }: VariantHintProps) => {
  let message = null;

  if (minimum && minimum > 0) {
    if ((!maximum && minimum === 1) || (maximum === 1 && minimum === 1)) {
      message = <T _str="required" />;
    } else if (!maximum && minimum > 1) {
      message = <T _str="required, at least {minimum}" minimum={minimum} />;
    } else if (maximum && minimum === 1) {
      message = <T _str="required, select up to {maximum}" maximum={maximum} />;
    } else if (maximum && minimum > 1) {
      message = (
        <T
          _str="required, at least {minimum} and select up to {maximum}"
          minimum={minimum}
          maximum={maximum}
        />
      );
    }
  } else if (maximum) {
    message = <T _str="select up to {maximum}" maximum={maximum} />;
  }

  if (!message) return null;

  return <p className={variantHintStyles({ error })}>{message}</p>;
};
